class FeaturedProductsCarouselNosto extends HHBaseElement {
  constructor() {
    super()
    this.resultId = this.dataset.resultId
    this.$products = []
    this.$placementID = this.dataset.id
    this.sectionHeadline = this.dataset.sectionHeadline
    this.sectionSubheadline = this.dataset.sectionSubheadline
    this.titleRecommended = ''
    this.$container = this.querySelector(
      '.featured-products-carousel-nosto__container'
    )
    this.$titleContainer = this.querySelector(
      '.featured-products-carousel__heading'
    )
    this.$subheadingContainer = this.querySelector(
      '.featured-products-carousel__subheading'
    )

    this.$carouselWrapper = this.querySelector(
      '.featured-products-carousel__wrapper'
    )

    this.runNosto = this.runNosto.bind(this)
    this._generateSimpleSlider = this._generateSimpleSlider.bind(this)
    this._generateList = this._generateList.bind(this)
    this._generateProductCard = this._generateProductCard.bind(this)
  }

  runNosto() {
    window.__NOSTO_RECOMMENDER__?.getRecommendation().then((response) => {
      if (typeof response.recommendations[this.$placementID] !== 'undefined') {
        this.$products = response.recommendations[
          this.$placementID
        ].products.filter((product) => !product.tags1.includes('free'))
        this.titleRecommended =
          response.recommendations[this.$placementID].title
        this.resultId = response.recommendations[this.$placementID].result_id

        if (this.sectionHeadline) {
          this.$titleContainer.innerHTML = this.sectionHeadline
        } else if (!!this.closest('#ns-gift-ocp')) {
          this.$titleContainer.classList.add('hidden')

          const giftModule = this.closest('#ns-gift-ocp')
          const backgroundColor =
            window.getComputedStyle(giftModule).backgroundColor
          const carousels = giftModule.querySelectorAll(
            '.nosto-placements .featured-products-carousel'
          )

          if (carousels.length > 0) {
            carousels.forEach((carousel) => {
              carousel.style.backgroundColor = backgroundColor
            })
          }
        } else if (this.titleRecommended) {
          this.$titleContainer.innerHTML = this.titleRecommended
        } else {
          this.$titleContainer.classList.add('hidden')
        }
        if (this.sectionSubheadline) {
          this.$subheadingContainer.innerHTML = this.sectionSubheadline
        } else {
          this.$subheadingContainer.classList.add('hidden')
        }
        if (this.$products.length > 0) {
          this.buildCarousel()
        } else {
          this.remove()
        }
      } else {
        this.remove()
      }
    })
  }

  buildCarousel() {
    this.$container.innerHTML = ''

    const wrapperElem = document.createElement('div')
    wrapperElem.className = 'featured-products-carousel__products'
    wrapperElem.innerHTML = this._generateSimpleSlider()

    this.$container.appendChild(wrapperElem)

    const swiperEl = this.querySelector('swiper-container')
    const $self = this
    const swiperParams = {
      navigation: 'true',
      slidesPerView: 1.25,
      spaceBetween: 20,
      watchSlidesProgress: true,
      breakpoints: {
        540: { slidesPerView: 2, spaceBetween: 20 },
        680: { slidesPerView: 2.5, spaceBetween: 20 },
        990: {
          slidesPerView: this.isInsideNostoPopup ? 3 : 4,
          spaceBetween: 30,
        },
      },
      on: {
        init() {
          $self._setAlly(swiperEl)
        },
        slideChange() {
          $self._setAlly(swiperEl)
        },
      },
    }
    Object.assign(swiperEl, swiperParams)
    swiperEl.initialize()
  }

  _setAlly(swiperEl) {
    swiperEl.querySelectorAll('swiper-slide').forEach((slide) => {
      if (slide.classList.contains('swiper-slide-visible')) {
        slide.setAttribute('aria-hidden', false)
        slide.setAttribute('tabindex', 0)
      } else {
        slide.setAttribute('aria-hidden', true)
        slide.setAttribute('tabindex', -1)
      }
    })
  }

  _generateSimpleSlider() {
    const listContents = this._generateList()
    return `
      <div class='featured-products-carousel__slider'>
        ${listContents}
      </div>
    `
  }

  get isInsideNostoPopup() {
    return !!this.closest('#NostoPopUp')
  }

  get cardSize() {
    return this.isInsideNostoPopup && this.dataset.cardVersion !== 'redesign'
      ? 'card-size="small"'
      : ''
  }

  _generateList() {
    const productsList = this.$products.map(this._generateProductCard)

    return `
    <swiper-container role='list' init="false" class='featured-products-carousel__slider-items hide-scrollbars flex no-margin' data-slider-items a11y-slide-role='listitem'>
        ${productsList.join('')}
      </swiper-container>
    `
  }

  _generateProductCard(item, key) {
    let index = key + 1
    let totalProductSlides = this.$products.length
    const variantId = item?.recommended_sku?.id || item.product_id
    return `
    <swiper-slide class='featured-products-carousel__slider-item' aria-label="Product Card Slide ${index} of ${totalProductSlides}" data-slider-item>
        <product-card
          class="product-card"
          hydrate
          data-id="${variantId}"
          product-handle="${item.url.split('/').slice(-1)}"
          url-postfix='nosto=${this.resultId}'
          data-product-href="${item.url}"
          data-product-image-primary="${item.image_url}"
          data-product-image-secondary="${item.alternate_image_urls[0] || ''}"
          data-product-title="${item.name}"
          data-product-description=""
          data-product-price="${item.price}"
          data-section-headline="${this.sectionHeadline}"
          ${this.cardSize}
          ${this.dataset.cardTitleTag ? `title-tag="${this.dataset.cardTitleTag}"` : ''}
          role="group"
          aria-label="${window.productCardStrings.product}"
        ></product-card>
      </swiper-slide>
    `
  }

  connectedCallback() {
    this.runNosto()
    this.addEventListener('click::add-to-cart', (event) => {
      window.__NOSTO_RECOMMENDER__?.trackAddToCart(
        event.detail.product_id,
        this.resultId
      )
    })

    this.addEventListener('click::quick-shop-toggle', (event) => {
      window.__NOSTO_RECOMMENDER__?.trackProductView(
        event.detail.product_id,
        this.resultId
      )
    })
  }
}

window.customElements.define(
  'featured-products-carousel-nosto',
  FeaturedProductsCarouselNosto
)
